const terrains = [
	{
		name: "saint_jean",
		description: "Saint-Jean de Sault",
		lat: 44.0412,
		lon: 5.4035,
		secteurs: ["SW", "W", "NW"],
		code_ffvl:1746,
	},
	{
		name: "rissas",
		description: "Rissas Beaumont du Ventoux",
		lat: 44.1958,
		lon: 5.1675,
		secteurs: ["S", "SW"],
		code_ffvl:13236,
	},
	{
		name: "ventoux_sud_la_chappelle",
		description: "Mont Ventoux Sud La Chapelle",
		lat: 44.1737,
		lon: 5.2693,
		secteurs: ["SE", "S"],
		code_ffvl:13509,
	},
	{
		name: "ventoux_sud_les_cretes",
		description: "Mont Ventoux Sud Les Cretes",
		lat: 44.1739,
		lon: 5.2644,
		secteurs: ["SE", "S"],
		code_ffvl:1767,
	},
	{
		name: "ventoux_nord",
		description: "Mont Ventoux Nord",
		lat: 44.1747,
		lon: 5.2785,
		secteurs: ["N", "NE", "NW"],
		code_ffvl:1764,
	},
	{
		name: "le-seigneur",
		description: "Monieux le seigneur",
		lat: 44.0878,
		lon: 5.363,
		secteurs: ["NE", "E"],
		code_ffvl:13469,
	},
	{
		name: "banon",
		description: "Banon Grou de Bane",
		lat: 44.0497,
		lon: 5.6355,
		secteurs: ["E", "SE", "S", "SW"],
		code_ffvl:199,
	},
	{
		name: "contras",
		description: "Contras",
		lat: 44.1165,
		lon: 5.7239,
		secteurs: ["SW", "W", "NW"],
		code_ffvl:1301,
	},
	{
		name: "nyons_garde_grosse",
		description: "Nyons Garde Grosse",
		lat: 44.3367,
		lon: 5.1543,
		secteurs: ["W", "NW"],
		code_ffvl:139,
	},
	{
		name: "beauvoisin_col_de_mirande",
		description: "Beauvoisin Col de Mirande",
		lat: 44.3,
		lon: 5.2361,
		secteurs: ["SW", "W", "SE"],
		code_ffvl:1016,
	},
	{
		name: "Sainte_Jalle_Soubeyrand",
		description: "Col de Soubeyrand",
		lat: 44.3756,
		lon: 5.3331,
		secteurs: ["S", "SW", "W"],
		code_ffvl:673,
	},
	{
		name: "buc_ouest",
		description: "Buc Ouest",
		lat: 44.2127,
		lon: 5.4784,
		secteurs: ["W", "NW"],
		code_ffvl:210,
	},
	{
		name: "mevouillon_le_fort",
		description: "Mévouillon le Fort",
		lat: 44.2371,
		lon: 5.4823,
		secteurs: ["E"],
		code_ffvl:213,
	},
	{
		name: "mevouillon_la_trappe",
		description: "Mévouillon la Trappe",
		lat: 44.2529,
		lon: 5.5065,
		secteurs: ["S"],
		code_ffvl:215,
	},
	{
		name: "rustrel",
		description: "Rustrel",
		lat: 43.9419,
		lon: 5.4763,
		secteurs: ["W"],
		code_ffvl:197,
	},
	{
		name: "saint_amand",
		description: "Saint Amand Nord",
		lat: 44.1864,
		lon: 5.06833,
		secteurs: ["N", "NW"],
		code_ffvl:1865,
	},
	{
		name: "saint_hippolyte",
		description: "Saint Hippolyte le Graveyron",
		lat: 44.1326,
		lon: 5.075,
		secteurs: ["S"],
		code_ffvl:1855,
	},
	{
		name: "Hey_haut",
		description: "Col d'Ey-Haut",
		lat: 44.3092,
		lon: 5.2824,
		secteurs: ["N", "NE", "NW"],
		code_ffvl:13589,
	},
	{
		name: "bergies_nord",
		description: "Bergies Nord",
		lat: 44.2037,
		lon: 5.5107,
		secteurs: ["N","NW","W","SE","S"],
		code_ffvl:219,
	},
	{
		name: "bergies_sud",
		description: "Bergies Sud",
		lat: 44.2032,
		lon: 5.5105,
		secteurs: ["SE","S"],
		code_ffvl:220,
	},
	{
		name: "Hey_principal",
		description: "Col d'Hey principal",
		lat: 44.31111,
		lon: 5.2817,
		secteurs: ["N", "NW"],
		code_ffvl:671,
	},
	{
		name: "Mont_Serein",
		description: "Mont Serein (Atterrissage)",
		lat: 44.1844,
		lon: 5.2601,
		secteurs: ["N", "NE", "NW", "S", "SE", "SW", "E", "W"],
		code_ffvl:1765,
	},
	{
		name: "Saint_Jean_att",
		description: "Saint_Jean (Atterrissage)",
		lat: 44.039,
		lon: 5.396,
		secteurs: ["N", "NE", "NW", "S", "SE", "SW", "E", "W"],
		code_ffvl:1746,
	},
	{
		name:"Eyguiere_Romaniere",
		description: "Eyguiere Romanière",
		lat: 43.7021,
		lon: 4.9854,
		secteurs:["S","SW"],
		code_ffvl:1875,
	}
];
export default terrains;
